module.exports = __webpack_public_path__ + "static/media/Auto-1.9f8a662e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Auto-1.png
// module id = 316
// module chunks = 0